import { DataCache, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { PersonProfilePopupResponse } from 'data/models/PersonProfilePopupResponse';

export class PersonProfilePopupCache extends DataCache {
    PersonProfilePopupResponses = PCCollection(PersonProfilePopupResponse);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship(this.PersonProfilePopupResponses, data.PCUsers, r => r.PCUser, null);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/personprofilepopup/cache.ts